/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconNavigationMessages = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M13.992 4.331L9.065 8.5a1.676 1.676 0 0 1-2.123.003L2.011 4.33a1.65 1.65 0 0 0-.344 1.003v6.668c0 .184.149.333.333.333h12.002a.334.334 0 0 0 .334-.333V5.334c0-.378-.131-.723-.344-1.002z"
    />
    <path
      fill="currentColor"
      d="M8.637 7.988l4.845-4.1a1.645 1.645 0 0 0-.814-.222H3.333c-.297 0-.572.085-.814.221l4.85 4.103c.364.3.899.3 1.268-.003z"
    />
  </svg>
);

IconNavigationMessages.displayName = 'IconNavigationMessages';

IconNavigationMessages.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconNavigationMessages);
IconNavigationMessages.displayName = 'IconNavigationMessages';
